import {
  Box,
  Button,
  MenuItem,
  Stack,
  TableCell,
  TableFooter,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React from "react";

const PdfPageKind = [
  { id: 2, kind: "Morisawa Fonts 購入申請書" },
  { id: 1, kind: "発注書兼納期回答書" },
  { id: 0, kind: "不要ページ" },
];

class PairTableSynnex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newFormPairList: props.formPairList || { pageConfiguration: [] },
    };
  }

  handleInputChange = (e, rowIndex) => {
    const newFormPairList = { ...this.state.newFormPairList };
    newFormPairList.pageConfiguration[rowIndex].pageKind = parseInt(
      e.target.value,
      10
    ); // pageKindを更新
    this.setState({ newFormPairList });
    this.props.onSave(newFormPairList);
  };

  render() {
    const { newFormPairList } = this.state;

    const PdfPageKindSelect = ({ value, rowIndex }) => (
      <TextField
        select
        value={value}
        onChange={(e) => this.handleInputChange(e, rowIndex)}
        variant="outlined"
        fullWidth
      >
        {PdfPageKind.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.kind}
          </MenuItem>
        ))}
      </TextField>
    );

    const columns = [
      {
        name: "管理番号 " + this.props.processNo,
        options: {
          setCellProps: () => ({
            style: {
              textAlign: "center", // センター揃え
            },
          }),
        },
      },
      {
        name: "",
        options: {
          customBodyRender: (value, tableMeta) => {
            if (value === "") {
              return "";
            }
            return (
              <img
                src={value}
                alt={`Thumbnail ${tableMeta.rowIndex + 1}`}
                style={{ width: "100px", height: "auto" }}
              />
            );
          },
        },
      },
      {
        name: "",
        options: {
          customBodyRender: (value, tableMeta) => {
            return (
              <PdfPageKindSelect value={value} rowIndex={tableMeta.rowIndex} />
            );
          },
        },
      },
    ];

    const data = (newFormPairList.pageConfiguration || []).map((config, i) => [
      "P " + (i + 1),
      config.thumbnailPath,
      config.pageKind,
    ]);

    const options = {
      search: false,
      print: false,
      download: false,
      filter: false,
      viewColumns: false,
      selectableRows: "none",
      rowsPerPage: 100,
      customFooter: (
        count,
        page,
        rowsPerPage,
        changeRowsPerPage,
        changePage
      ) => {
        return (
          <TableFooter>
            <TableRow>
              <TableCell colSpan={3}>
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography sx={{ fontSize: "0.8rem" }}>
                    ページ毎に該当するページの種類（ Morisawa Fonts
                    購入申請書｜発注書兼納期回答書｜不要ページ
                    ）を選択し「登録」を実行してください
                  </Typography>
                  <Typography sx={{ fontSize: "0.8rem" }}>
                    （全 {count} 行）
                  </Typography>
                </Stack>
              </TableCell>
            </TableRow>
          </TableFooter>
        );
      },
    };

    return (
      <Box display="flex" flexDirection="column" alignItems="flex-end" p={2}>
        <Box mb={4}>
          <Button
            variant="contained"
            color="primary"
            href={newFormPairList.baseInfo?.pdfPath || "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            申請書 PDF
          </Button>
        </Box>

        {/* テーブルの幅を100%に設定 */}
        <Box width="100%">
          <MUIDataTable
            // title="SYNNEX 対指定"
            data={data}
            columns={columns}
            options={options}
          />
        </Box>
      </Box>
    );
  }
}

export default PairTableSynnex;
